
import { authHeader } from '../_helpers';
import { CONST } from '../_config';

export const surveyService = {
    responseAnalysisBySurveyId,
    getCampaignEmployeesByIDSurveyWise,
    getIndexByFilterDMG,
    getResponseAnalyticsPagination
};
function logout() {
    localStorage.removeItem('adminuser');
    window.location.href = "#/insight/signin";
}

function handleResponse(response) {
    // //////console.log("response22222   ", response);
 
     return response.text().then(text => {
         const data = text && JSON.parse(text);
         if (!response.ok) {
             if (response.status === 401) {
                 // auto logout if 401 response returned from api
                 logoutSession();
                 //location.reload(true);
             }
             // //////console.log("datadatadata ", response);
 
             const error = (data && data.message) || response.statusText;
             return Promise.reject(error);
         }
         ////////console.log("datadatadatadatadata   ", data.error);
         if (data.error) {
             ////////console.log("datadatadatadatadata ---------------------->  ", data);
             if (data.code===3) {
                 logoutSession();
             }
             if(data && data.message && (data.message === "UnauthorizedError")){
                logout()

             }
//              else if (data.code===1) {
//                 logoutSession();
//             }
             const error = (data && data.message) || response.statusText;
             return Promise.reject(error);
         }
         return data;
     });
 }
 
 

function handleResponse2(response) {
    // //////console.log("response22222   ", response);
 
     return response.text().then(text => {
         const data = text && JSON.parse(text);
         if (!response.ok) {
             if (response.status === 401) {
                 // auto logout if 401 response returned from api
                 logout();
                 //location.reload(true);
             }
             // //////console.log("datadatadata ", response);
 
             const error = (data && data.message) || response.statusText;
             return Promise.reject(error);
         }
         ////////console.log("datadatadatadatadata   ", data.error);
         if (data.error) {
             // //////console.log("datadatadatadatadata   ", data);
             if (data.code===3) {
                 logout();
             }
             const error = (data && data.message) || response.statusText;
             return Promise.reject(error);
         }
         return data;
     });
 }
 






function logoutSession(data) {

    let header = new Headers({
            'Content-Type': 'application/json',
            'Authorization': authHeader().Authorization
        });
        const requestOptions = {
            method: "POST",
            headers: header,
            body: JSON.stringify(data)
        }
        return fetch(CONST.BACKEND_URL + `/userlogout`, requestOptions)
            .then(handleResponse2)
            .then(user => {
                let userObj = {
                    userLogout: user
                }
                localStorage.removeItem('adminuser');
                window.location.href = "#/insight/signin";
                return userObj;
            });
}





async function responseAnalysisBySurveyId(data) {
    let backendUrl = await JSON.parse(localStorage.getItem('backendUrl'));
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/responseAnalysisBySurveyId`, requestOptions)

        .then(handleResponse)
        .then(data => {

            // //console.log('x responseAnalysisBySurveyIdData',data.data)
            let surveyObj = {
                responseAnalysisBySurveyIdData: data.data
            }

            return surveyObj;
        });
}

async function getCampaignEmployeesByIDSurveyWise(data) {
    let backendUrl = await JSON.parse(localStorage.getItem('backendUrl'));
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getCampaignEmployeesByIDSurveyWise`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let surveyObj = {
                getCampaignEmployeesByIDSurveyWiseData: data.data
            }
            //console.log('x getCampaignEmployeesByIDSurveyWise',surveyObj)

            return surveyObj;
        });
}
async function getIndexByFilterDMG(data) {
    let backendUrl = await JSON.parse(localStorage.getItem('backendUrl'));
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_SURVEY_URL + `/getIndexByFilterDMG`, requestOptions)

        .then(handleResponse)
        .then(data => {
            let surveyObj = {
                getIndexByFilterDMGData: data.data
            }
            return surveyObj;
        });
}


async function getResponseAnalyticsPagination(data) {
    let backendUrl = await JSON.parse(localStorage.getItem('backendUrl'));
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    
    return fetch(CONST.BACKEND_SURVEY_URL + `/getResponseAnalyticsPagination`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let surveyObj = {
                getResponseAnalyticsPaginationData: data.data
            }
            return surveyObj;
        });
}






